import firebase from 'firebase/app'
import 'firebase/auth'
import EventEmitter from 'events';
const loginEvent = 'loginEvent';

class AuthService extends EventEmitter {

    // highestRole(roles){
    //     let ordered = {};
    //     ordered = roles.sort(function(a, b) {
    //       return (a.id) - (b.id);
    //     });
    //     return ordered[0].name;
    //   }

    handleAuthentication() {
        return new Promise((resolve, reject) => {
            // TODO: test
            if (false) {
                
                reject('someerr');
            } else {

                resolve('sometok');
            }
        });
    }
}

export default new AuthService();
